import styles from './PopupBaseComponent.module.css'
import { GetMaxZIndex } from '../../../utils/UtilitaryFunctions'
import { useContext, useEffect, useRef } from 'react';
import { GlobalContext } from '../../../contexts/globalContext';


const PopupBaseComponent = ({children, width, marginLeft, flexDirection = ""}) => {

    const ref = useRef()

    const { keyboardRef } = useContext(GlobalContext)

    useEffect(() => {
        ref.current.style.zIndex = GetMaxZIndex() + 1
        keyboardRef.current.hideIt()
    },[])
    
    return (
        <div ref={ref} className={styles.component} style={{ flexDirection: flexDirection, width:width, marginLeft: marginLeft, justifyContent: flexDirection ? "center" : ""}}>
            {children}
        </div>
    );

}

export default PopupBaseComponent;